"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const pages = [{
  num: "01",
  title: "Engajamento",
  path: "/ServicesPage",
  desc: "O vídeo retém a atenção do usuário por muito mais tempo, aumentando as taxas de conversão e o tempo de permanência em suas plataformas digitais."
}, {
  num: "02",
  title: "Autoridade",
  path: "/StudioPage",
  desc: "Produções de alta qualidade transmitem profissionalismo e confiança, posicionando sua marca como líder no mercado audiovisual e digital."
}, {
  num: "03",
  title: "Resultados",
  path: "/PortfolioPage",
  desc: "Estratégias baseadas em conteúdo visual geram maior ROI, facilitando a compreensão de produtos complexos e acelerando a jornada de compra."
}];
export default function SiteStructure() {
  return <section data-section-id="223342" id="importância-do-vídeo" className="relative w-full overflow-hidden bg-background py-24 md:py-32 text-foreground">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative">
        {}
        <div className="relative grid grid-cols-1 md:grid-cols-12 border-l border-r border-border/30">
          
          {}
          <div className="hidden md:block absolute top-0 bottom-0 left-[33.333333%] w-px bg-border -translate-x-1/2 z-0" />

          {}
          <div className="absolute top-0 bottom-0 right-4 w-32 md:w-48 pointer-events-none hidden sm:block z-10">
            <div className="sticky top-1/3 mt-12 md:mt-24">
              <AspectRatio ratio={4 / 3}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/pinheiros_studio_set.png" alt="Professional film set in Pinheiros studio" className="h-full w-full object-cover border border-border rounded-lg grayscale-0 contrast-100 opacity-100 shadow-xl" />
              </AspectRatio>
            </div>
          </div>

          <div className="col-span-1 md:col-span-12 flex flex-col w-full relative z-20">
            {}
            <div className="relative w-[110vw] left-1/2 -translate-x-1/2 h-px bg-border" />

            {pages.map((page, i) => <Link key={page.num} to={page.path} data-index={i} className="group relative block w-full bg-background hover:bg-primary/5 transition-colors duration-300">
                <div className="grid grid-cols-1 md:grid-cols-12 items-stretch min-h-[160px]">
                  {}
                  <div className="col-span-1 md:col-span-4 p-6 md:p-10 flex items-start gap-4 md:gap-6 border-b md:border-b-0 border-border/30">
                    <span className="font-mono text-sm md:text-base text-primary mt-1.5 md:mt-2 shrink-0">
                      {page.num}
                    </span>
                    <h3 className="font-serif font-bold text-3xl md:text-4xl lg:text-5xl tracking-tight text-foreground transition-transform duration-300 ease-out group-hover:translate-x-3">
                      {page.title}
                    </h3>
                  </div>

                  {}
                  <div className="col-span-1 md:col-span-8 p-6 md:p-10 flex items-center md:pr-40 lg:pr-56">
                    <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground transition-all duration-300 group-hover:text-foreground max-w-2xl">
                      {page.desc}
                    </p>
                  </div>
                </div>

                {}
                <div className="relative w-[110vw] left-1/2 -translate-x-1/2 h-px bg-border transition-colors duration-300 group-hover:bg-primary" />
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}